<template>
  <div class="card bg-white" style="height: 100vh; ">
    <BehfamLOGO name="در حال بارگذاری..." style="position:absolute; right: 50%; top: 40%;"/>
  </div>
</template>
<script  >
import {defineComponent} from "vue";
import BehfamLOGO from "@/components/Icons/BehfamLOGO.vue";

export default defineComponent({
  components: {BehfamLOGO}
})
</script>